var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/anonymous/Mobile/components/SeeMoreLink.js",
  _this = this;
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ListItem, Typography, Icon } from '@sm/wds-react';
var titleClassname = classNames('sm-mobile-menu__type-title', 'sm-mobile-menu-anon--has-arrow-icon', 'sm-mobile-menu-anon--no-subtitle');
export var SeeMoreLink = function SeeMoreLink(_ref) {
  var title = _ref.title,
    url = _ref.url,
    openInNewWindow = _ref.openInNewWindow;
  return /*#__PURE__*/React.createElement(ListItem, Object.assign({
    key: title,
    isNavigable: true,
    navigationTarget: url,
    className: "sm-mobile-menu__nested-item"
  }, openInNewWindow === true && {
    target: '_blank',
    rel: 'noopener noreferrer'
  }, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "sectionTitle",
    color: "link",
    className: titleClassname,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 7
    }
  }, title, /*#__PURE__*/React.createElement(Icon, {
    className: "sm-mobile-menu__arrow-icon",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 9
    }
  }, "]")));
};
export default SeeMoreLink;
SeeMoreLink.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  openInNewWindow: PropTypes.bool
};
SeeMoreLink.defaultProps = {
  openInNewWindow: false
};
//# sourceMappingURL=SeeMoreLink.js.map